import React, { useState, useEffect } from 'react';
import LayoutWithSidebar from 'components/v2/LayoutWithSidebar';
import { useParams } from 'react-router-dom';
import DataPoller from 'components/ui/DataPoller';
import CustomerActionCreators from 'actions/CustomersActionCreators';
import { getCustomerV2 } from 'utils/CustomersAPIUtils';
import Spinner from 'components/ui/Spinner';
import _ from 'underscore';
import CargomaticCard from 'components/v2/card';
import CarrierDriverWebAPIUtils from 'utils/CarrierDriverWebAPIUtils';
import CustomerStore from 'stores/CustomerSearchStore';
import AuditHistory from 'components/modules/shipments/AuditHistory';
import CommentList from 'components/modules/comments/CommentList';
import { useTranslation } from 'react-i18next';
import Sidebar from '../../carrier/AdminSidebar';
import RecentActivity from '../recent-activity';
const POLLING_FREQ = 10000;
const Loading = function () {
    return (React.createElement("div", { className: "justify-center lg:col-span-1", style: { top: '50%' } },
        React.createElement("div", { className: "align-middle" },
            React.createElement("span", { className: "text-5xl text-green" },
                React.createElement(Spinner, { showMessage: false })))));
};
const ActivitySettings = () => {
    const { t } = useTranslation();
    const [carrier, setCarrier] = useState(null);
    const [audits, setAudits] = useState([]);
    const [page, setPage] = useState(1);
    const [isLoading, setIsLoading] = useState(true);
    const params = useParams();
    const carrierId = params.id;
    const renderSidebar = () => (React.createElement(Sidebar, { userId: carrierId, activePage: "activity" }));
    const breadcrumbs = {
        pages: [
            {
                name: (carrier === null || carrier === void 0 ? void 0 : carrier.name) || t('CARRIER'),
                href: `/users/${carrierId}`,
                current: false,
            },
            {
                name: 'Activity',
                href: `/users/${carrierId}/carrier-settings/activity`,
                current: true,
            },
        ],
    };
    const onAuditChange = () => {
        const auditsRes = CustomerStore.getCustomerAudits();
        setIsLoading(false);
        if (!_.isEqual(auditsRes, audits)) {
            return setAudits(auditsRes);
        }
    };
    const fetchUser = async () => {
        const user = await getCustomerV2(carrierId);
        setCarrier(user);
    };
    const getUserAudits = () => {
        CustomerActionCreators.fetchCustomerAudits(carrierId, { page });
    };
    const handleAddComment = (message) => {
        CarrierDriverWebAPIUtils.addDriverComment(carrierId, message);
    };
    useEffect(() => {
        fetchUser();
        CustomerStore.addAuditChangeListener(onAuditChange);
        return () => {
            setIsLoading(true);
            CustomerStore.removeAuditChangeListener(onAuditChange);
        };
    }, [page]);
    return (React.createElement(LayoutWithSidebar, { sidebar: renderSidebar, breadcrumbs: breadcrumbs, className: "py-4" }, carrier ? (React.createElement(React.Fragment, null,
        React.createElement(DataPoller, { action: getUserAudits, frequency: POLLING_FREQ }),
        React.createElement("div", { className: "mb-6" },
            React.createElement(RecentActivity, { email: carrier.email })),
        React.createElement(CargomaticCard, { className: "mb-6", removeHorizontalPadding: true, removeVerticalPadding: true, header: () => React.createElement("h3", { className: "my-0" }, t('ACCOUNT_DISCUSSION')) },
            React.createElement(CommentList, { comments: carrier.comments, onCommentAdd: handleAddComment, paginate: true })),
        React.createElement(CargomaticCard, { className: "mb-6 col-span-1", header: () => React.createElement("h3", { className: "my-0" }, t('AUDIT_HISTORY')) },
            React.createElement(AuditHistory, { audits: audits, paginate: true, onClick: (page) => {
                    setPage(page);
                }, currentPage: page, isLoading: isLoading })))) : (React.createElement(Loading, null))));
};
export default ActivitySettings;
